// components/JobApprovals.tsx
import React from 'react';
import { CheckCircle, XCircle, BookOpen, User, Zap, Info } from 'lucide-react';

const JobApprovals = ({ applications, onApprove, onReject }: any) => {
  return (
    <div className="space-y-4 p-4">
      {applications.length === 0 ? (
        <div className="text-center py-10 bg-gray-50 rounded-2xl border-2 border-dashed border-gray-200">
          <p className="text-sm text-gray-400 font-medium italic">No pending tutor applications to review.</p>
        </div>
      ) : (
        applications.map((app: any) => (
          <div key={app.id} className="bg-white p-6 rounded-2xl border border-gray-100 shadow-sm flex flex-col md:flex-row justify-between items-center gap-6 hover:border-blue-200 transition-all">
            
            {/* 📚 Application Info */}
            <div className="flex-1 w-full">
              <div className="flex items-center gap-2 mb-2">
                <span className="bg-blue-100 text-blue-600 text-[10px] font-black px-2 py-1 rounded-md uppercase tracking-wider">
                  {app.job?.subject || "General Subject"}
                </span>
                <span className="text-gray-400 text-[10px] font-bold uppercase tracking-tight">
                  Student: {app.job?.student?.fullName || "N/A"}
                </span>
                
                {/* 💡 Visual Hint for the Admin: Show Tutor's Current Rate */}
                <div className="ml-auto flex items-center gap-1.5 bg-gray-50 px-2 py-1 rounded-md border border-gray-100">
                  <Info size={10} className="text-gray-400" />
                  <span className="text-[9px] font-black uppercase text-gray-500">
                    Tutor default: {app.tutor?.customCommissionRate ? `${app.tutor.customCommissionRate * 100}%` : '30% (Global)'}
                  </span>
                </div>
              </div>
              
              <h3 className="font-black text-slate-800 text-lg flex items-center gap-2 leading-none">
                <User size={18} className="text-blue-500" /> {app.tutor?.fullName}
              </h3>
              
              <div className="mt-2 p-3 bg-slate-50 rounded-xl border border-slate-100">
                <p className="text-slate-600 text-xs italic leading-relaxed">
                  "{app.message || 'No pitch message provided by tutor.'}"
                </p>
              </div>
            </div>

            {/* ⚙️ Action Area */}
            <div className="flex flex-row md:flex-col gap-2 w-full md:w-auto">
              <button 
                // 🚀 BOTH IDs PASSED: app.id (Application) and app.jobId (The specific Job/Subject)
                onClick={() => onApprove(app.id, app.job?.id || app.jobId)}
                className="flex-1 flex items-center justify-center gap-2 bg-blue-600 text-white px-6 py-3 rounded-2xl text-xs font-black uppercase tracking-widest hover:bg-blue-700 shadow-lg shadow-blue-200 transition-all active:scale-95"
              >
                <Zap size={16} /> Approve & Set Rate
              </button>
              
              <button 
                onClick={() => onReject(app.id)}
                className="flex-1 flex items-center justify-center gap-2 bg-red-50 text-red-600 px-6 py-3 rounded-2xl text-xs font-black uppercase tracking-widest hover:bg-red-100 transition-all"
              >
                <XCircle size={16} /> Reject
              </button>
            </div>
          </div>
        ))
      )}
    </div>
  );
};

export default JobApprovals;